/* SLIDE 7 */
/* SLIDE 9 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedSpot } from "features/parking/presentation/store/parkingSlice";
import SubHeader from "../../../shared/components/SubHeader";

const ParkingSetting2 = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { parkingSpots, selectedSpot } = useSelector((state) => state.parking);

    const handleSpotClick = (spot) => {
        dispatch(setSelectedSpot(spot));
        navigate("/parking_spot_setting");
    };

    return (
        <div className={`parking-status-container`}>
            <div className="setting-mode">
                <SubHeader>
                    <div className="nl-row f-column">
                        <span className="htBold">주차면 설정</span>
                        <div className={`sub-header-text w-full`}>
                            <span className="htColorGray2">주차장명 : </span>
                            <span className="htBold">새마을시장(01-002)</span>
                        </div>
                    </div>

                </SubHeader>
                <div>
                    <p className="text-description">
                        주차면을 선택하여 주차면을 세부설정 합니다.
                    </p>
                </div>
                <div className="parking-grid pg-setting">
                    {parkingSpots?.map((spot, index) => (
                        <div
                            key={spot.id}
                            className="parking-slot"
                            onClick={() => handleSpotClick(spot)}
                        >
                            <div className="slot-number">{spot.id}</div>
                            <div className="slot-status">
                                {index == 0 ? '장애인주차구역' : spot.name}
                                <br />
                                {index == 0 ? '(장애인)' : ''}
                            </div>
                            {spot.name === "" ? (
                                <div className="slot-status">{spot.status}</div>
                            ) : (
                                ""
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ParkingSetting2;
